import { GROUPS, SHORTCUTS, displayKey } from "../shortcuts";
import { Dialog } from "../ui/Dialog";

/** shortcuts_dialog.py: every shortcut by group, drawn from the same table the key handler uses. */
export function ShortcutsDialog({ onClose }: { onClose: () => void }) {
  return (
    <Dialog title="Keyboard Shortcuts" onClose={onClose} width={620} testId="shortcuts">
      {GROUPS.map((g) => {
        const rows = SHORTCUTS.filter((s) => s.group === g && (s.scope === "gesture" || s.webKeys.length > 0));
        return (
          <section key={g} style={{ marginBottom: 12 }}>
            <div className="field-caption" style={{ marginBottom: 4 }}>{g}</div>
            {rows.map((s) => (
              <div key={s.id} style={{ display: "grid", gridTemplateColumns: "200px 1fr", gap: 12, padding: "3px 0" }} data-testid={`sc-${s.id}`}>
                <span style={{ fontFamily: '"JetBrains Mono", monospace', fontSize: 12 }}>
                  {(s.scope === "gesture" ? s.desktopKeys : s.webKeys).map((k) => displayKey(k)).join("  /  ")}
                </span>
                <span>{s.label}</span>
              </div>
            ))}
          </section>
        );
      })}
      <div className="dialog-actions"><button className="btn primary" onClick={onClose}>Close</button></div>
    </Dialog>
  );
}
